import OrdersTable from "./OrdersTable";

export default function OnHold() {
  return <OrdersTable type="on-hold" />;
}
